import { useCallback } from 'react'
import {
  withDefault,
  NumberParam,
  StringParam,
  createEnumParam,
  useQueryParams
} from 'use-query-params'
import {
  SORTING_DRAFT,
  SORTING_NEW,
  SORTING_OLD,
  SORTING_PUBLISHED
} from '@plandi/common'

const SortProjectsMeParam = createEnumParam([
  SORTING_NEW,
  SORTING_OLD,
  SORTING_PUBLISHED,
  SORTING_DRAFT
])

export const ProjectsMeFiltersQueryParamConfigMap = {
  keyword: withDefault(StringParam, undefined, true),
  sort: withDefault(SortProjectsMeParam, undefined, true),
  categoryId: withDefault(NumberParam, undefined, true)
}

export const useProjectsMeFilters = () => {
  const [projectsMeFilters, setParams] = useQueryParams(
    ProjectsMeFiltersQueryParamConfigMap
  )

  const setProjectsMeFilters = useCallback(
    (value: Partial<typeof projectsMeFilters>) => {
      setParams((oldValue) => ({ ...oldValue, ...value }))
    },
    [setParams]
  )

  const clearProjectMeFilters = () => {
    setParams((filter) =>
      Object.fromEntries(Object.keys(filter).map((key) => [key, undefined]))
    )
  }

  return { ...projectsMeFilters, clearProjectMeFilters, setProjectsMeFilters }
}
